import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickDelete } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberGoogleScholar } from "./routeType";

const { key, getPath } = getApi("members.googleScholar.delete");

type IExtractedRouteType =
  IMemberGoogleScholar["googleScholarDataSingleDelete"];

export type IDeleteMemberGoogleScholar = IPickDelete<IExtractedRouteType>;

const deleteMemberGoogleScholar: Fetcher<
  IDeleteMemberGoogleScholar["response"],
  IDeleteMemberGoogleScholar["variables"]
> = ({ memberId }) => {
  return axiosClient.delete(getPath({ memberId }));
};

export const useDeleteMemberGoogleScholar = createQuery({
  queryKey: [key],
  fetcher: deleteMemberGoogleScholar,
});
